import Confirm from './Confirm';

const postCreationUrls = ['/questions/new', '/announcements/new', '/chats/new'];

export default class Header {
  constructor() {
    this.initDom();
    this.setEvents();
  }

  initDom() {
    this.$html = $('html');
    this.$initiator = $('.js-Header');
    this.$searchWindow = this.$initiator.find('.c-Search');
    this.$AdvancedSearchLink = this.$initiator.find('.st-AdvancedSearch_Link');
  }

  setEvents() {
    if (this.$searchWindow.length > 0) {
      $(document).on('click', (e) => {
        this.searchToggle(e);
      });
    }

    if (this.$AdvancedSearchLink.length > 0) {
      $('.js-AdvancedSearch_Link').on('click', (e) => {
        if (postCreationUrls.some((path) => location.pathname.includes(path))) {
          Confirm.confirm({
            message: 'このページを離れますか？\n離れると投稿は保存されません。',
            acceptCallback: () => this.setKeyword(e.currentTarget),
          });
        } else {
          this.setKeyword(e.currentTarget);
        }
      });
    }
  }

  searchToggle({ target }) {
    const $t = $(target);
    const hide = () => {
      this.$searchWindow.get(0).dataset.expend = false;
      this.$html.removeClass('-search-locked');
    };

    if (
      !$t.closest('[data-header-search]').length &&
      !$t.closest('.c-Search').length
    ) {
      hide();
    } else if ($t.closest('[data-header-search]').length) {
      if (this.$searchWindow.get(0).dataset.expend === 'false') {
        this.$searchWindow.get(0).dataset.expend = true;
        this.$html.addClass('-search-locked');
      } else {
        hide();
      }
    } else if ($t.closest('[data-header-search-close]').length) {
      if (!this.$searchWindow.is(':hidden')) {
        hide();
      }
    }
  }

  stringify(targetObject) {
    return Object.entries(targetObject).reduce((queries, current) => {
      let key = encodeURIComponent(current[0]);
      let value = encodeURIComponent(current[1]);
      return (queries += (queries === '' ? '' : '&') + `${key}=${value}`);
    }, '');
  }

  setKeyword(ele) {
    const searchForm = document.querySelector('.c-Search_Form');
    if (searchForm) {
      const nextQueryParams = {};
      // 詳細検索のキーワードが設定されていればそれを優先し、なければ全体検索のキーワードを設定
      const advancedKeyword =
        searchForm['search_community_content_advanced[keyword]']?.value;
      const generalKeyword =
        searchForm['search_community_content[keyword]']?.value;
      nextQueryParams['search_community_content_advanced[keyword]'] =
        advancedKeyword ?? generalKeyword ?? '';

      location.href =
        location.origin +
        '/community_contents/advanced_search' +
        `?${this.stringify(nextQueryParams)}`;
    }
  }
}
